import { InfoAlert } from '@/General/InfoAlert'
import { TextLink } from '@/General/TextLink'

export const CommunityRulesAlert = () => {
  return (
    <InfoAlert variant="info" title="A few guidelines before you post">
      • No exposure, questions, or discussions about methods
      <br />
      • Please be respectful: no insults, mocking comments, or profane or vulgar
      language
      <br />• Questions about stock, availability etc. should be{' '}
      <TextLink href="/contact-us/">emailed</TextLink> and not posted here
      <br />• This area is for questions and <em>not</em> critique of the
      product or trailer. Please use the review section for that!
      <br />• Please{' '}
      <strong>
        no questions about where to find the instructions or password
      </strong>
      . They should be emailed.
    </InfoAlert>
  )
}
